import useSWR from "swr";
import { PATH_INVENTARIOS } from "../constants/routes";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers";
import { axiosConToken } from "../helpers/axios";
import { types } from "../types/typesInventarioInicial";

const key = "key_inventarioinicial ";

export const inventarioInicialStartLoad = ({
  almacen = null,
  search = null,
  page = 1,
  page_size = 10,
}) => {
  return async (dispatch) => {
    dispatch(ShowLoading());
    try {
      const resp = await axiosConToken.get(PATH_INVENTARIOS.inventarioinicial, {
        params: { almacen, search, page, page_size },
      });
      dispatch(inventarioInicialLoaded(resp.data));
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(ShowLoading(false));
    }
  };
};
export const inventarioInicialStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_INVENTARIOS.inventarioinicial,
        data
      );
      const { msg, inventarioinicial } = resp.data;
      dispatch(inventarioInicialInserted(inventarioinicial));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const inventarioInicialStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_INVENTARIOS.inventarioinicial}${data.id}/`,
        data
      );
      const { msg, inventarioinicial } = resp.data;
      dispatch(inventarioInicialUpdated(inventarioinicial));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const inventarioInicialStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_INVENTARIOS.inventarioinicial}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(inventarioInicialDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const inventarioInicialStartProcess = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    dispatch(ShowLoading());
    try {
      const resp = await axiosConToken.get(
        `${PATH_INVENTARIOS.inventarioinicial}procesar_inventarioinicial/`,
        { params: { inventarioinicial: data?.id } }
      );
      const { msg, inventarioinicial } = resp.data;
      dispatch(inventarioInicialUpdated(inventarioinicial));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    } finally {
      dispatch(ShowLoading(false));
    }
  };
};
const inventarioInicialLoaded = (inventarioinicial) => ({
  type: types.inventarioinicialLoaded,
  payload: inventarioinicial,
});
const inventarioInicialInserted = (inventarioinicial) => ({
  type: types.inventarioinicialAdded,
  payload: inventarioinicial,
});
const inventarioInicialUpdated = (inventarioinicial) => ({
  type: types.inventarioinicialUpdated,
  payload: inventarioinicial,
});
const inventarioInicialDeleted = (inventarioinicial) => ({
  type: types.inventarioinicialDeleted,
  payload: inventarioinicial,
});
export const inventarioInicialSetActive = (inventarioinicial) => ({
  type: types.inventarioinicialSetActive,
  payload: inventarioinicial,
});
export const inventarioInicialClearActive = () => ({
  type: types.inventarioinicialClearActive,
});
const ShowLoading = (loading = true) => ({
  type: types.inventarioinicialLoading,
  payload: loading,
});
export const cargar_data_excel = async (formData) => {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  try {
    const resp = await axiosConToken.post(
      `${PATH_INVENTARIOS.inventarioinicial}cargar_data_excel/`,
      formData,
      config
    );
    return resp?.data;
  } catch (error) {
    validaMessagesErrors(error.response);
  }
};
export const useEstadosInventarioInicial = () => {
  const { data, isLoading, error } = useSWR(
    `${PATH_INVENTARIOS.inventarioinicial}get_estadosinventarioinicial/`
  );
  if (error) {
    validaMessagesErrors(error);
    return {
      data: [],
      isLoading: false,
      error,
    };
  }
  return {
    data: data || [],
    isLoading,
    error: null,
  };
};
